// This class restricts the users ability to tab through elements
// Passing in the classes applied to the start and end elements will cause it to loop through these only
// Useful for overlays or lightboxes if you don't want to tab through elements underneath

// Libraries
var $ = require('jquery');

class RestrictTab {
    setup = (startSelector, endSelector) => {
        let startElement = $(startSelector);
        let endElement = $(endSelector);
        
        $(document).on('keydown', function(e) {
            if(e.keyCode === 9) {
                if(e.target === endElement.get(0)) {
                    e.preventDefault();
                    startElement.focus();
                }
            }
        });
    }

    destroy = () => {
        $(document).off('keydown');
    }
}

module.exports = RestrictTab;


// WEBPACK FOOTER //
// ./src/common/Accessibility/RestrictTab.js